import { useContext } from "react";
import { AuthContext, AuthContextType } from "../context/auth";

export default function useAuth(): AuthContextType {
  return useContext(AuthContext);
}
